<template>
  <div class="frecuency-field">
    <span class="frecuency-field-title" :style="'color:' + titleColor">
      {{ $t('recipe.frequency') }}
    </span>

    <div class="frecuency-field-items">
      <v-text-field v-model="frequencyAmount" type="number" step="1" min="1" max="100" @blur="checkNumber" />

      <v-select item-value="value" :items="units" :value="frequencyUnit" @blur="checkNumber" />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  props: {
    amount: {
      type: Number,
      default: 1,
    },

    unit: {
      type: [String, null],
      default: null,
    },
  },

  data: () => ({
    frequencyAmount: 1,
    frequencyUnit: null,
  }),

  computed: {
    ...mapState({
      appThemePrimary: state => state.app.styles.themePrimary,
    }),

    titleColor() {
      return this.appThemePrimary || '#1976d2';
    },

    units() {
      return [
        { text: this.$t('recipe.hours'), value: this.$t('recipe.hours') },
        { text: this.$t('recipe.days'), value: this.$t('recipe.days') },
        { text: this.$t('recipe.weeks'), value: this.$t('recipe.weeks') },
        { text: this.$t('recipe.months'), value: this.$t('recipe.months') },
      ];
    },
  },

  watch: {
    amount() {
      this.frequencyAmount = this.amount;
    },
    unit() {
      this.frequencyUnit = this.unit;
    },
  },

  created() {
    if (this.unit === null) {
      this.frequencyUnit = this.$t('recipe.hours');
      this.update(this.frequencyAmount, this.frequencyUnit);
    }
  },

  methods: {
    update(amount, unit) {
      this.$emit('update', { amount, unit });
    },

    checkNumber() {
      const min = 1;
      const max = 100;

      if (!isNaN(this.frequencyAmount) && this.frequencyAmount !== '') {
        this.frequencyAmount = parseInt(String(this.frequencyAmount));
      } else {
        this.frequencyAmount = 1;
      }

      if (0 > max && this.frequencyAmount > max) {
        this.frequencyAmount = max;
      }
      if (this.frequencyAmount < min) {
        this.frequencyAmount = min;
      }
      this.update(this.frequencyAmount, this.frequencyUnit);
    },
  },
};
</script>

<style lang="scss" scoped>
.frecuency-field-title {
  margin-bottom: 0.8em;
  font-weight: bold;
  font-size: 1rem;
}

.frecuency-field-items {
  display: flex;

  > div:not(:first-child) {
    margin-left: 2rem;
  }
}
</style>
